import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useItems(params) {
  const { data, ...rest } = useQuery('items', () =>
    apiCalls.getItems(params).then(({ data: { items, totalCount } }) => ({
      items,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}

export function useItemsForOrder({ secondLevelCategory, thirdLevelCategory, requiresThirdLevel, onSuccess }) {
  const { data, ...rest } = useQuery(
    ['items', { secondLevelCategory, thirdLevelCategory }],
    () =>
      apiCalls.getItems({ secondLevelCategory, thirdLevelCategory }).then(({ data: { items, totalCount } }) => ({
        items,
        totalCount,
      })),
    {
      onSuccess: (data) => {
        onSuccess(data);
      },
      enabled: requiresThirdLevel ? !!secondLevelCategory && !!thirdLevelCategory : !!secondLevelCategory,
    }
  );
  return { result: data, ...rest };
}

export function useItemEdit() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    ({ item }) => apiCalls.editItem({ item }).then(({ data: { item } }) => item),
    {
      onSuccess: (item) => {
        queryClient.invalidateQueries('items');
        return item;
      },
    }
  );
  return { editItem: mutate, ...rest };
}

export function useItemCategoryEdit(onSuccess) {
  const { mutate, ...rest } = useMutation(
    ({ itemCategory }) => apiCalls.editItemCategory({ itemCategory }).then(({ data: { categories } }) => categories),
    {
      onSuccess: (itemCategory) => {
        onSuccess(itemCategory);
        return itemCategory;
      },
    }
  );
  return { editItemCategory: mutate, ...rest };
}

export function useItemFirstLevelCategories(params) {
  const { data, ...rest } = useQuery('coupons', () =>
    apiCalls.getItemFirstLevelCategories(params).then(({ data: { categories } }) => categories)
  );
  return { categories: data, ...rest };
}
